import { Component } from '@theme/component';
import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

/** Loads Liquid-rendered history cards without replacing the product page. */
class RecentlyViewedSection extends Component {
  #controller;

  connectedCallback() {
    super.connectedCallback();
    this.#controller = new AbortController();
    this.#load(this.#controller.signal);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
    if (this.dataset.sectionId) sectionRenderer.abortRender(this.dataset.sectionId);
  }

  /** @param {AbortSignal} signal */
  async #load(signal) {
    const { sectionId, productId, limit } = this.dataset;
    if (!sectionId) return;
    // Record here too: section modules can execute before the global tracking script.
    if (productId) RecentlyViewed.addProduct(productId);
    const ids = RecentlyViewed.getProducts().filter((id) => id !== productId).slice(0, Number(limit) || 4);
    if (!ids.length) return;

    const url = new URL(Theme.routes.search_url, location.origin);
    url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[unavailable_products]', 'show');
    try {
      await sectionRenderer.renderSection(sectionId, {
        url,
        cache: false,
        mode: 'hydration',
        injectStylesheet: true,
        shouldRender: () => this.isConnected && !signal.aborted,
      });
    } catch (error) {
      if (!signal.aborted) console.error('Unable to load recently viewed products:', error);
    }
  }
}

if (!customElements.get('recently-viewed-section')) {
  customElements.define('recently-viewed-section', RecentlyViewedSection);
}
